import { render, staticRenderFns } from "./DispatchArrivalRegistratTabel.vue?vue&type=template&id=118e3fcf&scoped=true&"
import script from "./DispatchArrivalRegistratTabel.vue?vue&type=script&lang=js&"
export * from "./DispatchArrivalRegistratTabel.vue?vue&type=script&lang=js&"
import style0 from "./DispatchArrivalRegistratTabel.vue?vue&type=style&index=0&id=118e3fcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e3fcf",
  null
  
)

export default component.exports